import ScreenshotActions from './screenshot-actions';
import ScreenshotOverlayGantt from './screenshot-overlay-gantt';

export default class GanttDemoAction extends ScreenshotActions {
    static trackingSubtype = 'interactive_screeshot';
    static trackingContent = 'gantt';
    static interactionCount = 3;

    get counter() {
        return this._counter;
    }
    set counter(value) {
        this._counter = value;
    }
    get overlay() {
        return this._overlay;
    }
    set overlay(value) {
        this._overlay = value;
    }

    constructor(screenshot, event, type, onAdd, onRemove, onSuccess) {
        super(screenshot, event, type, onAdd, onRemove, onSuccess);
        this.$modal = $('#modal-contact-us-screenshots');
        this.$form = this.$modal.find('form');
        this.$trackigSubtype = this.$form.find('[name="tracking-subtype"]');
        this.$trackigContent = this.$form.find('[name="tracking-content"]');
        this._overlay = null;
        this._counter = 1;

        WG.Observable.fromEvent(this.$form.wgInstance().$element.eq(0), 'success.contact-sales').subscribe(() => {
            if (this.$form.find('[name="tracking-content"]').val() === 'gantt') {
                this.overlay.hide();
                this.stopTracking();
            }
        });
    }

    validate() {
        if (this.counter >= GanttDemoAction.interactionCount) {
            return true;
        }

        this.counter += 1;
        return false;
    }

    execute() {
        this.overlay = new ScreenshotOverlayGantt(this.screenshot, this.onClick.bind(this));
        this.overlay.init().show();
    }

    onClick() {
        this.$trackigSubtype.val(GanttDemoAction.trackingSubtype);
        this.$trackigContent.val(GanttDemoAction.trackingContent);
        this.$modal.wgInstance().show();
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/gantt-demo.js